<template>
    <figure class="image__wrapper loaded" style="text-align: center;">
        <!-- <a-spin class="image__spinner" /> -->
        <div class="ripple image__spinner">
            <div class="ripple__circle"></div>
            <div class="ripple__circle ripple__inner-circle"></div>
        </div>
        <img class="image__item" @error="handle()" :src="source" style="width: 40px; height: 40px; border-radius: 20px;" alt="clock">
        <!-- <img class="image__item" :src="source" style="width: 40px; height: 40px; border-radius: 20px;" alt="clock"> -->
    </figure>
</template>

<script>
import unknown_file from '@/assets/unknown_file.png'
export default {
    name: ``,
    data: () => ({
        source: '',
        defaultImage: unknown_file
    }),
    props: {
        src: { required: false, type: String, default: '' }
    },
    watch: {
        src(val) {
            this.source = val
        }
    },
    created() {
        this.source = this.src
    },
    methods: {
        handle() {
            console.log('asdas')
            this.source = this.defaultImage
        }
    }
}
</script>

<style lang="scss" scoped>

.image {
  &__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;

    &.loaded {
      .image {
        &__item {
          visibility: visible;
          opacity: 1;
          border: 0;
        }

        &__spinner {
          display: none;
          width: 100%;
        }
      }
    }
  }

  &__item {
    // display: none;
    width: 100%;
    border-radius: 4px;
    transition: all 0.4s ease-in-out;
    opacity: 0;
    visibility: hidden;
  }
}

.ripple {
  display: inline-block;
  position: absolute;
  width: 64px;
  height: 64px;

  &__circle {
    position: absolute;
    border: 4px solid rgb(96, 208, 112);
    opacity: 1;
    border-radius: 50%;
    animation: ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }

  &__inner-circle {
    animation-delay: -0.5s;
  }
}

@keyframes ripple {
  0% {
    top: 28px;
    left: 28px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: -1px;
    left: -1px;
    width: 58px;
    height: 58px;
    opacity: 0;
  }
}
</style>